import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import CancelSettelmentModal from "../../components/modals/CancelSettelmentModal";
import OnlineSettlementConfirmModal from "../../components/modals/OnlineSettlementConfirmModal";
import SettelmentConfirmModal from "../../components/modals/SettelmentConfirmModal";
import { GetSettlementRequestDetailByKeyResponse } from "../../models/settlement.model";
import {
  deleteSettlementRequest,
  finalConfirmation,
  GetPaymentSettlementZipFile,
  getSettlementRequestDetailByKey,
} from "../../services/settlement.service";
import SettlementRequestDetailActionsHeader from "./components/settlementRequestDetailActionsHeader";
import SupplierSettelmentRequestDetailHeader from "./components/SupplierSettelmentRequestDetailHeader";
import SupplierSettelmentRequestDetailTable from "./components/SupplierSettelmentRequestDetailTable";
const SupplierSettementRequestDetail = () => {
  const [requestDetail, setRequestDetail] = useState<
    GetSettlementRequestDetailByKeyResponse
  >();
  const [openModal, setOpenModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const queryClient = useQueryClient();
  const history = useHistory<{
    settlementData?: {
      saleKey?: string;
      key?: string;
      branchId?: number;
      customerPersonId?: number;
    };
  }>();
  const settlementData =
    history?.location?.state?.settlementData !== undefined
      ? history?.location?.state?.settlementData
      : JSON.parse(
          window.localStorage.getItem("SETTLEMENT_REQUEST_DATA") || "{}"
        );

  const key = settlementData.key;
  const handleConfirm = () => {
    setOpenModal(true);
  };
  const handleCancalation = () => {
    setOpenCancelModal(true);
  };
  const handleDownloadDocs = () => {
    GetPaymentSettlementZipFileMutate({ key: key });
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleSubmitionModal = (values: any) => {
    FinalConfirmationMutate({
      ...values,
      key: key,
    });
  };
  const handleCloseCancelModal = () => {
    setOpenCancelModal(false);
  };
  const handleSubmitCancalation = () => {
    DeleteSettlementRequestMutate({
      key: key,
    });
  };

  const handlePrint = () => {
    window.print();
  };

  //service calls
  const { mutate: DeleteSettlementRequestMutate } = useMutation(
    deleteSettlementRequest,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          setOpenCancelModal(false);
          history.push("/SettelmentWithStoresList");
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetPaymentSettlementZipFileMutate } = useMutation(
    GetPaymentSettlementZipFile,
    {
      onSuccess: (data: any) => {
        if (data) {
        }
      },
      onError: () => {},
    }
  );
  const { mutate: getSettlementRequestDetailByKeyMutate } = useMutation(
    getSettlementRequestDetailByKey,
    {
      onSuccess: (data: GetSettlementRequestDetailByKeyResponse) => {
        if (data) {
          setRequestDetail(data);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: FinalConfirmationMutate } = useMutation(finalConfirmation, {
    onSuccess: (data: boolean) => {
      if (data) {
        setOpenModal(false);
        history.push({
          pathname: "/settlementHistoryDetail",
          state: { settlementData: { key: key } },
        });
        localStorage.setItem(
          "SETTLEMENT_REQUEST_DATA",
          JSON.stringify({ key: key })
        );
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    getSettlementRequestDetailByKeyMutate({
      key: key!,
    });
  }, [key]);

  // handles
  const handleClick = (
    key: string,
    branchId: number,
    customerPersonId: number
  ) => {
    const newWindow = window.open("/#/StoreRequestDetail", "_blank");
    newWindow?.sessionStorage.setItem(
      "SETTLEMENT_REQUEST_DATA",
      JSON.stringify({
        ...settlementData,
        saleKey: key,
        branchId,
        customerPersonId,
      })
    );

    newWindow?.history.pushState(
      {
        settlementData: {
          ...settlementData,
          saleKey: key,
          branchId,
          customerPersonId,
        },
      },
      "",
      "/StoreRequestDetail"
    );
  };

  return (
    <Grid container gap={"20px"} height={"fit-content"}>
      <Grid item xs={12} height={"5%"}>
        {!requestDetail?.confirmDate && (
          <SettlementRequestDetailActionsHeader
            handleConfirm={handleConfirm}
            handleCancalation={handleCancalation}
            handleDownloadDocs={handleDownloadDocs}
            handleExportExcel={() => {}}
            handlePrint={handlePrint}
          />
        )}
      </Grid>
      <Grid item xs={12} height={"20%"}>
        <SupplierSettelmentRequestDetailHeader
          creatorName={requestDetail?.creatorName || ""}
          createDate={requestDetail?.createDate || ""}
          createDatePersian={requestDetail?.createDatePersian || ""}
          creatorDescription={requestDetail?.creatorDescription || ""}
          settlementTypeTitle={requestDetail?.settlementTypeTitle || ""}
          settlementAmount={requestDetail?.settlementAmount || 0}
          factorAmount={requestDetail?.factorAmount || 0}
          confirmerName={requestDetail?.confirmerName || ""}
          confirmDate={requestDetail?.confirmDate || ""}
          confirmDatePersian={requestDetail?.confirmDatePersian || ""}
          confirmerDescription={requestDetail?.confirmerDescription || ""}
          sayadNumber={requestDetail?.sayadNumber || ""}
          chequeSeri={requestDetail?.chequeSeri || ""}
          chequeSerial={requestDetail?.chequeSerial || ""}
          chequeDueDate={requestDetail?.chequeDueDate || ""}
          chequeDueDatePersian={requestDetail?.chequeDueDatePersian || ""}
          settlementType={requestDetail?.settlementType!}
          key={requestDetail?.key!}
        />
      </Grid>
      <Grid item xs={12} height={"45vh"}>
        <SupplierSettelmentRequestDetailTable
          count={requestDetail?.sales?.length || 0}
          sales={requestDetail?.sales || []}
          handleRowClick={handleClick}
        />
      </Grid>
      {requestDetail?.settlementType === "Cheque" ? (
        <SettelmentConfirmModal
          open={openModal}
          setOpen={setOpenModal}
          handleSubmition={handleSubmitionModal}
          amount={requestDetail?.settlementAmount || 0}
        />
      ) : (
        <OnlineSettlementConfirmModal
          open={openModal}
          setOpen={setOpenModal}
          handleSubmition={handleSubmitionModal}
          handleClose={handleCloseModal}
          amount={requestDetail?.settlementAmount || 0}
        />
      )}
      <CancelSettelmentModal
        open={openCancelModal}
        setOpen={setOpenCancelModal}
        handleCancel={handleSubmitCancalation}
        handleClose={handleCloseCancelModal}
        amount={requestDetail?.settlementAmount || 0}
      />
    </Grid>
  );
};

export default SupplierSettementRequestDetail;
